export default __webpack_public_path__ + "static/storquest-e84c8eee79adc91d598694f0406289c1.png";